<!-- Lista de items -->
<div class="row d-flex">
  <div *ngFor="let item of section.items; let i = index" class="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-6 p-2"
    [ngClass]="{'col-12': item.comment === 'separator' || item.bestSeller, 'col-lg-12': item.bestSeller}">
    <div class="card" [ngStyle]="{'min-height': hasImage(item)? minHeigtItem: '0px',
    'max-height': maxHeigtItem, 'background': setBackground()}" *ngIf="item.comment !== 'separator' && !item.bestSeller">
      <img class="card-img-top animate__animated" [defaultImage]="loadingImage" [lazyLoad]="item.photo" loading="lazy" [alt]="item.photo.slice(83,item.photo.length)"
        [id]="item.photo.slice(83,item.photo.length)" *ngIf="hasImage(item)" (click)="open(item)">
      <div class="card-body p-2" (click)="open(item)">
        <!-- Label de recomendado -->
        <app-recommend *ngIf="item.home" [menu]="menu"></app-recommend>
        <h5 class="card-titlemeal-title font-weight-bold {{menu.fontHeader}} mb-1" [ngStyle]="{'color': getColor()}" translate="no">
          <ng-container *ngIf="!section.upperCaseName">
            {{ item.name | firstuppercase }}
          </ng-container>
          <ng-container *ngIf="section.upperCaseName">
            {{ item.name | uppercase }}
          </ng-container>
        </h5>
        <ng-container [ngTemplateOutlet]="description" [ngTemplateOutletContext]="{item: item}"></ng-container>
      </div>
    </div>
    <div class="col-12" *ngIf="item.comment === 'separator'">
      <app-separator [menu]="menu" [separator]="item"></app-separator>
    </div>
    <div class="col-12" *ngIf="item.bestSeller">
      <app-item [items]="[item]" [menu]="menu">
      </app-item>
    </div>
  </div>
</div>

<ng-template #description let-item="item">
  <!-- Descripcion del producto -->
  <div class="row">
    <!-- Descripcion en espanol -->
    <p class="meal-desc {{menu.fontText}}" *ngIf="language === 'ES'" [ngStyle]="{'color': getColor()}"
      [innerHTML]="descriptionParser.getParsedDescription(item, 'ES') | truncateSafeHtml:120">
    </p>
    <!-- Descripcion en ingles -->
    <p class="meal-desc {{menu.fontText}}" *ngIf="language === 'EN'" [ngStyle]="{'color': getColor()}"
      [innerHTML]="descriptionParser.getParsedDescription(item, 'EN') | truncateSafeHtml:120">
    </p>
  </div>
  <!-- Boton de ver mas y precio -->
  <div class="row font-weight-bold mt-2 {{menu.fontText}}">
    <div class="col-8 d-flex" [ngClass]="{'col-10': item.dollars && item.dollars !== ''}" *ngIf="item.price > 0 && item.price !== ''">
      <div class="p-0 {{menu.fontHeader}}"> <button class="itemPrice {{menu.fontHeader}}" [ngStyle]="{'color': getColor()}"><span class="font-weight-bold mt-4"
            [ngClass]="item.discount ? 'itemPrice--discount' : ''" translate="no">{{
            item.price
            |
            typeNumber: menu.units }}{{item.dollars && item.dollars !== ''? '/'+item.dollars+'usd': ''}}
          </span> <ng-container *ngIf="item.discount"> {{item.price - (item.price * (item.discount/100)) | typeNumber: menu.units }}</ng-container>
        </button></div>
    </div>
    <!-- <div class="btn-sm showMore p-1 text-center col-4" (click)="open(item)" [ngStyle]="{'color': getColor()}" *ngIf="hasImage(item) || item.description">
      <a>{{ language === 'ES'? 'Ver': 'View'}}</a>
    </div> -->
  </div>
</ng-template>